export default "/images/94d1e78f287a8b9606dbf08f54c43069.avif";